import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Heart, ArrowRight, ShieldCheck } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Articles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/articles`);
        setArticles(data);
      } catch (e) { /* ignore */ }
      setLoading(false);
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#FBF7F2]">
      <Navbar />
      <main className="px-6 lg:px-10 py-16">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <p className="section-eyebrow">Planning notes</p>
            <h1 className="font-serif text-5xl mt-3 text-[#2A2A2A]">Calm advice for actual humans.</h1>
            <p className="text-base text-[#6A6A6A] mt-3 max-w-xl mx-auto">No vendor ads, no SEO listicles. Just the seven articles we wish we&apos;d read when we were planning our own weddings.</p>
          </div>

          {loading ? (
            <div className="flex justify-center py-16"><Loader2 className="w-5 h-5 animate-spin text-[#7B2C3B]" /></div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((a) => (
                <Link
                  key={a.slug}
                  to={`/articles/${a.slug}`}
                  data-testid={`article-${a.slug}`}
                  className="soft-card rounded-3xl bg-white border border-[#EFE3D8] overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all"
                >
                  <div className="aspect-[16/10] bg-[#F4E4DA] overflow-hidden">
                    {a.cover && <img src={a.cover} alt="" className="w-full h-full object-cover" />}
                  </div>
                  <div className="p-5">
                    <span className="text-[10px] uppercase tracking-wider text-[#7B2C3B] font-medium">{a.category} · {a.readTime}</span>
                    <h3 className="font-serif text-xl text-[#2A2A2A] mt-2 leading-tight">{a.title}</h3>
                    <p className="text-sm text-[#6A6A6A] mt-2 line-clamp-3">{a.excerpt}</p>
                    <span className="inline-flex items-center gap-1 text-xs text-[#7B2C3B] mt-3">Read <ArrowRight className="w-3.5 h-3.5" /></span>
                  </div>
                </Link>
              ))}
            </div>
          )}

          <div className="mt-16 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[#EFE3D8] text-xs text-[#6A6A6A]">
              <ShieldCheck className="w-3.5 h-3.5 text-[#7B2C3B]" /> Written by humans. Edited by humans. Never AI-spammed.
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
